import CustomerRequestsAPI from '../../api/customerRequests';
import types from '../mutation-types';

export const state = {
  pendingCount: 0,
};

export const getters = {
  getPendingCount($state) {
    return $state.pendingCount;
  },
};

export const actions = {
  async fetchPendingCount({ commit }) {
    try {
      const { data } = await CustomerRequestsAPI.getMeta();
      commit(types.SET_CUSTOMER_REQUESTS_PENDING_COUNT, data.pending_count);
    } catch (error) {
      // The sidebar keeps its last count when this cannot load.
    }
  },
};

export const mutations = {
  [types.SET_CUSTOMER_REQUESTS_PENDING_COUNT]($state, count) {
    $state.pendingCount = Number(count) || 0;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
